export const GET_SOLICITATIONS_DECLINE_REASONS = "GET_SOLICITATIONS_DECLINE_REASONS"